export default defineNuxtPlugin(() => {
  const heightMap = {} as Record<string, number>
  const router = useRouter()
  const store = useStore()

  // Helps the browser to keep the scroll position the same, when a user navigates back to a certain page.
  router?.beforeEach((to: any, from: any, next: any) => {
    if (to.fullPath !== from.fullPath) {
      heightMap[from.fullPath] = document.body.clientHeight
      store.value.pageHeight = heightMap[to.fullPath] || 0
    }

    next()
  })
})
